import { dispatch } from "@rematch/core";
import React, { useEffect, useState } from "react";
import {
  Table,
  Dropdown,
  Segment,
  Header,
  Divider,
  Grid,
  Icon,
  Popup,
} from "semantic-ui-react";
import CountUp from "react-countup";
import LoadingComponent from "../../../../common/LoadingComponent";
import ConsumptionTable from "./ConsumptionTable";
import ConsumptionChart from "./ConsumptionChart";
import ConsumptionBarChart from "./ConsumptionBarChart";
import ConsumptionOperationsBarChart from "./ConsumptionOperationsBarChart";
import ConsumptionLineChart from "./ConsumptionLineChart";
import { DateRange } from "react-date-range";
import {
  startOfWeek,
  startOfMonth,
  subWeeks,
  format,
  differenceInDays,
  addDays,
  isValid,
} from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
export default class Consumptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRangeOptions: [
        { key: 1, text: "Today", value: "today" },
        { key: 2, text: "Last 7 Days", value: "last_7_days" },
        { key: 3, text: "Last 2 Weeks", value: "last_2_weeks" },
        { key: 4, text: "Last 30 Days", value: "last_30_days" },
        { key: 5, text: "Current Month", value: "current_month" },
        { key: 6, text: "Custom Range", value: "custom_range" },
      ],
      selectedRange: "last2Weeks",
      selectedWorkspace: "all",
      selectedPreset: "last2Weeks",
      selection: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
      showDropdown: false,
      loading: false,
      isMounted: false,
      consumptionDetailsGrouped: [],
      isDatePickerOpen: false,
      consumptionDetailsChart: {
        playbooksCreated: [],
        playbooksGenerated: [],
        playbooksPublished: [],
        activitiesGenerated: [],
        playbookExported: [],
        linksGenerated: [],
        initiativeCreated: [],
        // invitesCreated: [],
        // invitesUpdated: [],
        teamsCreated: [],
        scenarioExecution: [],
      },
      viewMode: false,
      consumptionCost: 0,
      totalCredits: 0,
      mountedConsumptionDetails: null,
    };
    this.dropdownRef = React.createRef();
    this.presets = [
      { label: "Week to Date", key: "weekToDate" },
      { label: "Last Week to Date", key: "lastWeek" },
      { label: "Last 2 Weeks to Date", key: "last2Weeks" },
      { label: "Month to Date", key: "monthToDate" },
      { label: "Custom Range", key: "custom" },
    ];
  }
  handleViewChange = (mode) => {
    this.setState({ viewMode: mode });
  };

  setPreset = async (key) => {
    this.setState({ selectedRange: key });
    const today = new Date();
    let startDate = null;
    let endDate = null;

    switch (key) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday start
        endDate = today;
        break;
      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today;
        break;
      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;
      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;
      case "custom":
        startDate = this.state.selection[0].startDate;
        endDate = this.state.selection[0].endDate;
        break;
      default:
        startDate = null;
        endDate = null;
    }
    const payload = {
      from_date: format(new Date(startDate), "yyyy-MM-dd"),
      to_date: format(new Date(endDate), "yyyy-MM-dd"),
      //   selectedAccountId: this.props.selectedAccount._id,
    };
    if (
      this.state.selectedWorkspace &&
      this.state.selectedWorkspace !== "all"
    ) {
      payload.selectedOrganizationId = this.state.selectedWorkspace;
    }
    await dispatch.account.getConsumptionDetails(payload);
    if (startDate && endDate) {
      this.setState({
        selectedPreset: key,
        selection: [
          {
            startDate,
            endDate,
            key: "selection",
          },
        ],
      });
    }
  };

  toggleDropdown = () => {
    this.setState((prev) => ({
      showDropdown: !prev.showDropdown,
    }));
  };

  handleWorkspaceChange = (e, { value }) => {
    this.setState({ selectedWorkspace: value });
    const today = new Date();
    let startDate = null;
    let endDate = null;
    switch (this.state.selectedRange) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }
    let payload = {
      from_date: startDate,
      to_date: endDate,
    };
    if (value && value !== "all") {
      payload.selectedOrganizationId = value;
    }
    dispatch.account.getConsumptionDetails(payload);
  };

  handleCustomDateChange = (item) => {
    this.setState({
      selection: [item.selection],
    });
    // let payload = {
    //   from_date:format(new Date(item.selection.startDate), 'yyyy-MM-dd'),
    //   to_date:format(new Date(item.selection.endDate), 'yyyy-MM-dd')
    // }
    // if (
    //   this.state.selectedWorkspace &&
    //   this.state.selectedWorkspace !== "all"
    // ) {
    //   payload.selectedOrganizationId = this.state.selectedWorkspace;
    // }
    // dispatch.account.getConsumptionDetails(payload);
  };

  selectedRange = (key) => {
    const today = new Date();
    let dates = [];
    let startDate = null;
    let endDate = null;

    switch (key) {
      case "weekToDate":
        startDate = startOfWeek(today, { weekStartsOn: 1 }); // Monday
        endDate = today;
        break;

      case "lastWeek":
        startDate = subWeeks(today, 1);
        endDate = today; // End of that week
        break;

      case "last2Weeks":
        startDate = subWeeks(today, 2);
        endDate = today;
        break;

      case "monthToDate":
        startDate = startOfMonth(today);
        endDate = today;
        break;

      case "custom":
        startDate = new Date(this.state.selection[0].startDate);
        endDate = new Date(this.state.selection[0].endDate);
        break;

      default:
        startDate = today;
        endDate = today;
    }

    if (isValid(startDate) && isValid(endDate)) {
      const numDays = differenceInDays(endDate, startDate) + 1;

      dates = Array.from({ length: numDays }, (_, i) =>
        format(addDays(startDate, i), "yyyy-MM-dd")
      );
    }

    return dates;
  };

  prepareExportChartData = () => {
    const dates = this.selectedRange(this.state.selectedRange);
    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");
      const dateKey = format(new Date(date), "yyyy-MM-dd");
      return {
        date: formattedDate,
        rawDate: date,
        PlayBookExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "PlaybookExport").length,
        WordExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "wordExport").length,
        ExcelExport: this.state.consumptionDetailsChart.playbookExported
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          )
          .filter((item) => item.data.type === "excelExport").length,
      };
    });
  };

  // for stashed chart
  prepareChartData = () => {
    let dates = this.selectedRange(this.state.selectedRange);

    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");

      return {
        date: formattedDate,
        rawDate: date,
        PlaybookCreated:
          this.state.consumptionDetailsChart.playbooksCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        PlaybookGenerated:
          this.state.consumptionDetailsChart.playbooksGenerated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        PlaybookPublished:
          this.state.consumptionDetailsChart.playbooksPublished.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        Activities: this.state.consumptionDetailsChart.activitiesGenerated
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          )
          .reduce((sum, item) => sum + (item.data.activitiesGenerated || 0), 0),
        Links: this.state.consumptionDetailsChart.linksGenerated
          .filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          )
          .reduce((sum, item) => sum + (item.data.linksGenerated || 0), 0),
        Exports: this.state.consumptionDetailsChart.playbookExported.filter(
          (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
        ).length,
        Initiatives:
          this.state.consumptionDetailsChart.initiativeCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
        Teams: this.state.consumptionDetailsChart.teamsCreated.filter(
          (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
        ).length,
        ScenarioExecution:
          this.state.consumptionDetailsChart.scenarioExecution.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === date
          ).length,
      };
    });
  };

  //for  bar charts
  prepareBarChartData = (type) => {
    const dates = this.selectedRange(this.state.selectedRange);

    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");
      const dateKey = format(new Date(date), "yyyy-MM-dd");

      let chartValue = 0;
      const chartData = this.state.consumptionDetailsChart;

      switch (type) {
        case "playbooksCreated":
          chartValue = chartData.playbooksCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "playbooksGenerated":
          chartValue = chartData.playbooksGenerated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "playbooksPublished":
          chartValue = chartData.playbooksPublished.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "activitiesGenerated":
          chartValue = chartData.activitiesGenerated
            .filter(
              (item) =>
                format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
            )
            .reduce(
              (sum, item) => sum + (item.data.activitiesGenerated || 0),
              0
            );
          break;

        case "linksGenerated":
          chartValue = chartData.linksGenerated
            .filter(
              (item) =>
                format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
            )
            .reduce((sum, item) => sum + (item.data.linksGenerated || 0), 0);
          break;

        case "playbookExported":
          chartValue = chartData.playbookExported.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "initiativeCreated":
          chartValue = chartData.initiativeCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "teamsCreated":
          chartValue = chartData.teamsCreated.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;

        case "scenarioExecution":
          chartValue = chartData.scenarioExecution.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;
        case "consumptionRequests":
          chartValue = this.props.consumptionDetails.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          ).length;
          break;
        default:
          chartValue = 0;
      }
      return {
        date: formattedDate,
        rawDate: date,
        value: chartValue,
      };
    });
  };
  //for  bar charts
  prepareOperationsBarChartData = () => {
    const dates = this.selectedRange(this.state.selectedRange);

    return dates.map((date) => {
      const formattedDate = format(new Date(date), "yyyy-MM-dd");
      const dateKey = format(new Date(date), "yyyy-MM-dd");

      let chartValue = 0;
      let requests = 0;
      const chartData = this.props.consumptionDetails;
          let consumptions = chartData.filter(
            (item) => format(new Date(item.createdAt), "yyyy-MM-dd") === dateKey
          );
          requests = consumptions.length;
          for (let consumption of consumptions) {
            if(consumption.data && consumption.data.noOfOperations){
            chartValue += consumption.data.noOfOperations;
            }
          }
      return {
        date: formattedDate,
        rawDate: date,
        operations: chartValue,
        requests: requests,
      };
    });
  };
  async componentDidUpdate(prevProps) {
    if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length > 0
    ) {
      const grouped = {};

      for (const item of this.props.consumptionDetails) {
        const playbookId = item.playbook && item.playbook._id;
        if (!playbookId) continue;

        const activities = (item.data && item.data.activitiesGenerated) || 0;
        const links = (item.data && item.data.linksGenerated) || 0;

        if (!grouped[playbookId]) {
          // Deep clone the item to preserve the full structure
          grouped[playbookId] = JSON.parse(JSON.stringify(item));
          grouped[playbookId].data.activitiesGenerated = activities;
          grouped[playbookId].data.linksGenerated = links;
        } else {
          grouped[playbookId].data.activitiesGenerated += activities;
          grouped[playbookId].data.linksGenerated += links;
        }
      }

      const groupedActivities = Object.values(grouped);
      this.setState({ consumptionDetailsGrouped: groupedActivities });

      const consumptionDetailsChart = {
        playbooksCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookCreated"
        ),

        playbooksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete"
        ),

        activitiesGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookComplete"
        ),

        playbooksPublished: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookPublished"
        ),

        playbookExported: this.props.consumptionDetails.filter(
          (item) => item.data.event === "PlaybookExported"
        ),

        linksGenerated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ActivityDetailsGenerated"
        ),

        initiativeCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "InitiativeCreated"
        ),

        teamsCreated: this.props.consumptionDetails.filter(
          (item) => item.data.event === "TeamCreated"
        ),
        scenarioExecution: this.props.consumptionDetails.filter(
          (item) => item.data.event === "ScenarioExecution"
        ),
      };
      let totalCost = 0;
      let totalCredits = 0;
      for (const item of this.props.consumptionDetails) {
        totalCost += item.data.consumptionCost || 0;
        totalCredits += item.data.noOfOperations || 0;
      }
      this.setState({ consumptionCost: totalCost,totalCredits });
      this.setState({ consumptionDetailsChart });
    } else if (
      prevProps.consumptionDetails !== this.props.consumptionDetails &&
      this.props.consumptionDetails.length === 0
    ) {
      this.setState({ consumptionDetailsGrouped: [], consumptionCost: 0, totalCredits: 0, 
        consumptionDetailsChart: {
          playbooksCreated: [],
          playbooksGenerated: [],
          playbooksPublished: [],
          activitiesGenerated: [],
          playbookExported: [],
          linksGenerated: [],
          initiativeCreated: [],
          // invitesCreated: [],
          // invitesUpdated: [],
          teamsCreated: [],
          scenarioExecution: [],
        } 
      });
    }
  }
  async componentWillMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({ loading: true });
    await this.setPreset("last2Weeks");
    const { consumptionDetails } = this.props;
    this.setState({
      loading: false,
      mountedConsumptionDetails: consumptionDetails,
    });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ showDropdown: false });
    }
  };

  render() {
    const {
      mountedConsumptionDetails,
      showDropdown,
      selection,
      selectedPreset,
    } = this.state;

    //for Main stashed bar chart
    const stashedBarConfig = [
      {
        dataKey: "PlaybookCreated",
        name: "Playbook Created Step By Step",
        fill: "#ec3a3a",
      },
      {
        dataKey: "PlaybookGenerated",
        name: "Playbook Generated With AI",
        fill: "#2599F7",
      },
      {
        dataKey: "PlaybookPublished",
        name: "Playbook Published",
        fill: "#797bfc",
      },
      {
        dataKey: "Activities",
        name: "Activities Generated",
        fill: "#8884d8",
      },
      {
        dataKey: "Links",
        name: "Links Researched",
        fill: "#82ca9d",
      },
      {
        dataKey: "Exports",
        name: "Playbooks Exported",
        fill: "#ffa600",
      },
      {
        dataKey: "Initiatives",
        name: "Projects / Initiatives Created",
        fill: "#eb7bf9",
      },
      {
        dataKey: "Teams",
        name: "Teams Created",
        fill: "#d35400",
      },
      {
        dataKey: "ScenarioExecution",
        title: "Make Scenarios Executed",
        fill: "#f4d03f",
      },
    ];

    //for Bar chart
    const chartConfig = [
      {
        key: "playbooksCreated",
        title: "Playbooks Created Step By Step",
        type: "playbooksCreated",
        color: "#ec3a3a",
      },
      {
        key: "playbooksGenerated",
        title: "Playbooks Generated With AI",
        type: "playbooksGenerated",
        color: "#2599F7",
      },
      {
        key: "playbooksPublished",
        title: "Playbooks Published",
        type: "playbooksPublished",
        color: "#797bfc",
      },
      {
        key: "playbookExported",
        title: "Playbooks Exported",
        type: "playbookExported",
        color: "#ffa600",
      },
      {
        key: "activitiesGenerated",
        title: "Activities Generated",
        type: "activitiesGenerated",
        color: "#8884d8",
      },
      {
        key: "linksGenerated",
        title: "Links Researched",
        type: "linksGenerated",
        color: "#82ca9d",
      },

      {
        key: "initiativeCreated",
        title: "Projects / Initiatives Created",
        type: "initiativeCreated",
        color: "#eb7bf9",
      },
      // {
      //   key: 'invitesCreated',
      //   title: 'Invites Sent',
      //   type: 'invitesCreated',
      //   color: '#DE3163'
      // },

      // {
      //   key: 'invitesUpdated',
      //   title: 'Invites Updated',
      //   type: 'invitesUpdated',
      //   color: '#7f0000'
      // },

      {
        key: "teamsCreated",
        title: "Teams Created",
        type: "teamsCreated",
        color: "#d35400",
      },
      {
        key: "scenarioExecution",
        title: "Make Scenarios Executed",
        type: "scenarioExecution",
        color: "#f4d03f",
      },
    ];

    const stashedExportBarConfig = [
      {
        dataKey: "PlayBookExport",
        name: "Playbook Exported",
        fill: "#ffa600",
      },
      {
        dataKey: "WordExport",
        name: "Word Exported",
        fill: "#ef5675",
      },
      {
        dataKey: "ExcelExport",
        name: "Excel Created",
        fill: "#7a5195",
      },
    ];
    let orgList =
      (this.props.organizations &&
        Array.from(
          new Map(
            this.props.organizations.map((org) => [
              org.id,
              {
                key: org.id,
                text: org.name,
                value: org.id,
              },
            ])
          ).values()
        )) ||
      [];
    orgList.unshift({
      key: "all",
      text: "All Workspaces",
      value: "all",
    });
    orgList = orgList.filter((item) => item.key && item.value);

    return (
      <div>
        <LoadingComponent
          active={this.props.loadingConsumptions || this.state.loading}
          message="Loading Consumption Details"
        />
        <div style={{border:"0.5px solid #D3D3D3"}} className="chart-container">
          <Header as="h4" style={{backgroundColor:"#f4f4f4ff", border:"0.5px solid #D3D3D3", padding:"7px"}}>Consumption Details</Header>

          {/* Main div */}
          <div style={{ display: "flex" }}>
            {/* Left div for graph*/}
            <div style={{ width: "75%", borderRight: "1px solid #d4d4d5" }}>
              {/* Selecting Worspace Range */}
              <div style={{marginLeft:"5px"}}>
                <div
                  style={{
                    display: "flex",
                    gap: "1em",
                    marginBottom: "1em",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <label style={{ marginRight: "5px" }}>
                    <strong>Workspace</strong>
                  </label>
                  <Dropdown
                    placeholder="Select Workspace"
                    selection
                    options={orgList}
                    value={this.state.selectedWorkspace}
                    onChange={this.handleWorkspaceChange}
                  />
                  <label style={{ marginRight: "5px" }}>
                    <strong>Date Range</strong>
                  </label>
                  <div className="date-range-selector-wrapper">
                    <button
                      className="dropdown-trigger"
                      onClick={this.toggleDropdown}
                    >
                      {selection[0].startDate && selection[0].endDate
                        ? `${format(
                            selection[0].startDate,
                            "MMM d, yyyy"
                          )} - ${format(selection[0].endDate, "MMM d, yyyy")}`
                        : "Select Date Range"}
                    </button>

                    {showDropdown && (
                      <div
                        className="popup-dropdown-overlay"
                        onClick={this.toggleDropdown}
                      >
                        <div
                          className="popup-dropdown"
                          ref={this.dropdownRef}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="date-range-dropdown">
                            <div className="presets-list">
                              {this.presets.map((preset) => (
                                <div
                                  key={preset.key}
                                  className={`preset-item ${
                                    selectedPreset === preset.key
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() => this.setPreset(preset.key)}
                                >
                                  {preset.label}
                                  {selectedPreset !== "custom" &&
                                    selectedPreset === preset.key && (
                                      <div className="preset-dates">
                                        {`${
                                          selection[0].startDate &&
                                          format(
                                            selection[0].startDate,
                                            "MMM d"
                                          )
                                        } - ${
                                          selection[0].endDate &&
                                          format(selection[0].endDate, "MMM d")
                                        }`}
                                      </div>
                                    )}
                                </div>
                              ))}
                            </div>

                            <div className="calendar-container">
                              <DateRange
                                onChange={(item) =>
                                  this.handleCustomDateChange(item)
                                }
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={2}
                                ranges={selection}
                                direction="horizontal"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{
                  height: "20px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div style={{marginLeft:"7px"}}>
                  <Header as="h5">
                    {
                      orgList.find(
                        (org) => org.value === this.state.selectedWorkspace
                      ).text
                    }{" "}
                    -{" "}
                    {
                      this.presets.find(
                        (opt) => opt.key === this.state.selectedRange
                      ).label
                    }
                  </Header>
                </div>
                <div
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px",
                  }}
                >
                  {/* <div>
                        <Icon name="list ul"   className={`${this.state.viewMode ? "icon_blue" : "icon_grey"} cursor-pointer`} onClick={() => this.handleViewChange(true)}/>
                      </div>  */}
                  {/* <div > 
                        <Icon name="th "   className={`${!this.state.viewMode ? "icon_blue" : "icon_grey"} `} />
                      </div>  */}
                </div>
              </div>
              <Grid
                columns="equal"
                celled="internally"
                className="count-block-item setHoverEffect"
                style={{
                  margin: "20px 0px 0px 0px",
                  border: "1px solid #d4d4d5",
                  borderRadius: "5px",
                }}
              >
                <Grid.Row>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp end={this.props.playbooksCreated} duration={5} />
                    {/* <span>{10}</span> */}
                    {/* } */}
                    <label>Playbooks Generated</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={this.props.activitiesGenerated}
                      duration={5}
                    />
                    {/* <span>{20}</span> */}
                    {/* } */}
                    <label>Activities Generated</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp end={this.props.linksGenerated} duration={5} />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Links Researched</label>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.playbooksCreated
                          ? this.state.consumptionDetailsChart.playbooksCreated
                              .length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Playbooks Created Step By Step</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.playbooksPublished
                          ? this.state.consumptionDetailsChart
                              .playbooksPublished.length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Playbooks Published</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.initiativeCreated
                          ? this.state.consumptionDetailsChart.initiativeCreated
                              .length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Projects/Initiatives Created</label>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.playbookExported
                          ? this.state.consumptionDetailsChart.playbookExported
                              .length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Playbooks Exported</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.teamsCreated
                          ? this.state.consumptionDetailsChart.teamsCreated
                              .length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Teams Created</label>
                  </Grid.Column>
                  <Grid.Column>
                    {/* {this.props.isLoadingData ? */}
                    <CountUp
                      end={
                        this.state.consumptionDetailsChart.scenarioExecution
                          ? this.state.consumptionDetailsChart.scenarioExecution
                              .length
                          : 0
                      }
                      duration={5}
                    />
                    {/* <span>{30}</span> */}
                    {/* } */}
                    <label>Total Make Scenarios Executed</label>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {/* Graphs Section */}
              {!this.state.viewMode && (
                <div
                  style={{
                    height: "calc(100vh - 200px)", // Adjust height based on header/other elements
                    width: "100%",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: "10px",
                    marginTop: "10px",
                  }}
                >
                  {/* --------------Stashed Bar Chart */}
                  <div style={{ marginTop: "10px", width: "100%" }}>
                    <div
                      style={{
                        overflowX: "auto",
                        overflowY: "hidden",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          // minWidth: ['today', 'last_7_days', 'last_2_weeks'].includes(this.state.selectedRange) ? '100%' : '1000px',
                          minWidth: ["today", "last_7_days"].includes(
                            this.state.selectedRange
                          )
                            ? "100%"
                            : ["last_2_weeks"].includes(
                                this.state.selectedRange
                              )
                            ? "500px"
                            : "1000px",
                          width: "100%",
                          height: "350px",
                          display: "flex",
                          flexDirection: "column",
                          maxWidth: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "12px",
                            transform: "translateX(35px)",
                            width: "20%",
                          }}
                        >
                          Total Spend - ${this.state.consumptionCost}
                        </div>
                        <ConsumptionChart
                          data={this.state.consumptionDetailsChart}
                          selectedRange={this.state.selectedRange}
                          customRange={this.state.customRange}
                          prepareChartData={this.prepareChartData}
                          chartConfig={stashedBarConfig}
                          height={350}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Bar charts  */}

                  <div style={{ marginTop: "10px", width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px 20px",
                      }}
                    >
                      {chartConfig.map((chart) => (
                        <div
                          key={chart.key}
                          style={{
                            width: "calc(50% - 15px)",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              transform: "translateX(35px)",
                            }}
                          >
                            {chart.title}
                          </div>

                          {/* Scrollable Chart */}
                          <div
                            style={{ overflowX: "auto", overflowY: "hidden" }}
                          >
                            <div
                              style={{
                                // minWidth: ['today', 'last_7_days'].includes(this.state.selectedRange)
                                //   ? '100%'
                                //   : '1000px',
                                // minWidth: ['today', 'last_7_days'].includes(this.state.selectedRange)
                                //   ? '100%'
                                //   :  ['last_2_weeks'].includes(this.state.selectedRange)
                                //     ? '500px'
                                //     : '1000px',
                                height: "300px",
                              }}
                            >
                              {chart.key === "playbookExported" ? (
                                <ConsumptionChart
                                  prepareChartData={this.prepareExportChartData}
                                  chartConfig={stashedExportBarConfig}
                                  height={300}
                                />
                              ) : (
                                <ConsumptionBarChart
                                  type={chart.type}
                                  title={chart.title}
                                  color={chart.color}
                                  prepareBarChartData={this.prepareBarChartData}
                                  height={300}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div style={{ width: "25%"}}>
              <div style={{ marginLeft: "5px" }}>
              <Header as="h4">Total Operations</Header>
              <div style={{ fontWeight:"bold"}}>
                {this.state.totalCredits || 0}
              </div>
              <div style={{ marginLeft: "5px",marginRight:"5px"}}> 
              <ConsumptionLineChart
                type={"operations"}
                title={"Total Requests"}
                color={"#2599F7"}
                height={150}
                lines={[
                  { key: "operations", color: "#2599F7", name: "Operations" },
                  { key: "requests", color: "#FF8A00", name: "Requests" },
                ]}
                prepareLineChartData={this.prepareOperationsBarChartData}/>
              </div></div>
              <Divider />
              <div style={{ marginLeft: "5px" }}>
              <Header as="h4">Total Requests</Header>
              <div style={{ fontWeight:"bold"}}>
                {this.props.consumptionDetails.length || 0}
              </div>
              <div style={{ marginLeft: "5px",marginRight:"5px"}}> 
              <ConsumptionOperationsBarChart
                type={"consumptionRequests"}
                title={"Total Requests"}
                color={"#2599F7"}
                height={150}
                prepareBarChartData={this.prepareBarChartData}/>
              </div></div>
              <Divider />
            </div>
          </div>
        </div>
        {/* {this.state.selectedWorkspace && this.state.viewMode && (
          <div>
            <ConsumptionTable data={this.state.consumptionDetailsGrouped} />
          </div>
        )} */}
      </div>
    );
  }
}
